<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5"> 
    <div class="container">
     <div class="">
    
      <div class="row mt-2 mt-md-0">
  
          <aside class="col-sm-6 col-md-4 col-lg-3">
            <app-userdashboard-sidebar>  </app-userdashboard-sidebar>  
                      </aside>
                      <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
                        <app-userheading-section></app-userheading-section>
                        <div class="row">
                          <div *ngIf="isLoading">

                          <div class="my-accountload text-center">
                            <span class="lodercont">
                              <app-refreshloader> </app-refreshloader>
                            </span>
                          </div>
                        </div>
                            <div class="col-md-12 mb-4">
                                <div class="profile-content orderlist-details h-100">
                                   <div class="row">
                                       <div class="col-md-6">
                                        <table class="table table-bordered">
                                            <thead class="thead-light">
                                              <tr>
                                                <th class="main-heading" colspan="2" scope="col"> {{ 'ord_detail.ord_details' | translate }} </th>
                                             </tr>
                                            </thead> 
                                            <tbody>
                                              <tr>
                                                <th scope="row">{{ 'ord_detail.ord_status' | translate }} </th>
                                                <td>{{ordDetail['orderid']}}</td>
                                              
                                              </tr>
                                              <tr>
                                                <th scope="row"> {{ 'ord_detail.place_date' | translate }}</th>
                                                <td>{{ordDetail['created_at'] | date : 'hh:mm a dd-MM-yyyy'}} </td> 
                                              </tr>
                                              <tr>
                                                <th scope="row">{{ 'ord_detail.ord_status' | translate }}  </th>

                                                <td *ngIf="showLang == 'en' " >{{this.ordStatus}}</td> 
                                                <td *ngIf="showLang == 'ar' " >{{this.ordStatus_ar}}</td>
                                             </tr>
                                              <tr>
                                                <th scope="row">{{ 'ord_detail.amount' | translate }} </th>
                                                <td> AED {{ordDetail['netPaid']}} </td>
                                             </tr>

                                             <tr>
                                              <th scope="row">{{ 'ord_detail.cutlery' | translate }} </th>
                                              <td *ngIf="ordDetail['isCutlery']; else nocutlery" >{{ 'ord_detail.yes' | translate }}</td>
                                              <ng-template #nocutlery>
                                                <td>{{ 'ord_detail.no' | translate }}</td>
                                              </ng-template>
                                              
                                           </tr>

                                            </tbody>
                                          </table>


                                           
                                        </div>

                                        <div class="col-md-6">
                                            <table class="table table-bordered">
                                                <thead class="thead-light">
                                                  <tr>
                                                    <th class="main-heading" colspan="2" scope="col"> {{ 'ord_detail.deliverto' | translate }} </th>
                                                 </tr>
                                                </thead>
                                                <tbody>
                                                  <tr> 
                                                    <th scope="row"> {{ 'ord_detail.pay_mode' | translate }}</th>
                                                    <td *ngIf="showLang == 'en' " >{{payMentMethod}} </td>
                                                    <td *ngIf="showLang == 'ar' " >{{payMentMethod_ar}} </td>
                                                  
                                                  </tr>
                                                  <tr>
                                                    <th scope="row"> {{ 'myaccount.name' | translate }} </th>
                                                    <td> {{ordDetail['uName']}} </td>
                                                  
                                                  </tr>
                                                  <tr>
                                                    <th scope="row">{{ 'myaccount.address' | translate }}</th>
                                                    <td> 
                                                      {{ordDetail['address_manual']}} <br>
                                                      {{ordDetail['city']}},{{ordDetail['state']}},{{ordDetail['address_country']}} </td>
                                                 </tr>
    
                                                  <tr>
                                                    <th scope="row"> {{ 'myaccount.phone' | translate }} </th>
                                                    <td class="call-us">{{ordDetail['phoneNumber']}}</td>
                                                 </tr>
    
                                                </tbody>
                                              </table>
                                         </div>
                                   </div>
                               <hr>
                              
                               <div class="row" *ngIf="ordDetail['isScheduled']">
                                <div class="col-md-6">
                                  <table class="table table-bordered"> 
                                      <thead class="thead-light">
                                        <tr>
                                          <th class="main-heading" colspan="2" scope="col">{{ 'checkout.shedule_delivery' | translate }}</th>
                                       </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th scope="row"> {{ 'checkout.d_date' | translate }} </th>
                                          <td>{{ordDetail['sdate'] | date : 'dd-MM-yyyy'}}</td>
                                        
                                        </tr>
                                        <tr>
                                          <th scope="row"> {{ 'checkout.from_time' | translate }}</th>
                                          <td>{{ordDetail['time_from']}} </td>
                                        
                                        </tr>
                                        <tr>
                                          <th scope="row">{{ 'checkout.to_time' | translate }} </th>
                                          <td>{{ordDetail['time_to']}}</td>
                                       </tr>

                                      </tbody>
                                    </table>
  
                                  </div>

                               </div>


                               <hr>
                               <h2 class="secmain-heading">{{ 'ord_detail.item_detail' | translate }}</h2>

                               <div class="media mb-2 my-order-box" *ngFor="let ordItem of ordDetail['OrderItems'] index as i" >
                                <div class="image ">
                                <img class="d-flex mr-2 img-fluid " src="{{imgurl}}{{ordItem['pImage']}}" alt="image">
                                  </div>
                                
                                  <div class="media-body items">
                                  
                                  <div class="row align-items-center">
                                  <div class="col-md-7 col-9">
                                  <h5 class="mt-0" *ngIf="showLang == 'en' " > {{ordItem['itemname']}} </h5>
                                  <h5 class="mt-0" *ngIf="showLang == 'ar' "> {{ordItem['itemname_ar']}} </h5>
                                  <p class="price">AED {{ordItem['pRate']}}</p>
                                  <p *ngFor="let addons of ordDetail['OrderItems'][i].adons">  
                                    <span *ngIf="showLang == 'en' " >{{addons['adon_value']}}</span> <span *ngIf="showLang == 'ar' " >{{addons['adon_value_ar']}}</span> (AED {{addons['adon_amount']}})
                                  </p>
        
                                  <p *ngFor="let varient of ordDetail['OrderItems'][i].options" >
                                    <span *ngIf="showLang == 'en' ">{{varient['option_value']}}</span> <span *ngIf="showLang == 'ar' ">{{varient['option_value_ar']}}</span>  <span *ngIf="varient['ovprice'] != 0" >(AED {{varient['ovprice']}})</span>
                                  </p>                                    

                                  <p *ngFor="let ing of ordDetail['OrderItems'][i].ingredents" >
                                    {{ing['ingValue']}} <span *ngIf="showLang == 'en' ">{{ing['ingName']}}</span> <span *ngIf="showLang == 'ar' ">{{ing['ingName_ar']}}</span> 
                                  </p>                                    
                                  
                                  <p *ngIf=" ordItem['pComent'] != null " >
                                    Additional Instruction: {{ordItem['pComent']}}
                                  </p>

                                  </div>

                                  <div class="col-md-2 col-3 pl-0  text-right">
                                    <span class="qty"> x {{ordItem['quantity']}} </span>
                                </div>

                                <div class="col-md-3 mt-2 mt-md-0 pl-md-0 text-md-right">
                                 
                                  <span class="qty">  AED {{ordItem['pTotal']}} </span>
                              </div>

                            </div> 
                            <hr>
     
                                </div>
                                
                              </div>

                              <hr>
                      
                              <div class="row sub-total">
                                
                                <div class="col-md-12  text-right">
                                  <span>{{ 'cart.cart_total' | translate }} : AED {{ordDetail['cart_total']}}</span><br>
                                  <span *ngIf="ordDetail['coupon_apply']">{{ 'ord_detail.coupon' | translate }}: ({{ordDetail['coupon_code']}})  AED - {{ordDetail['coupon_amount']}} </span><br>
                                  <span *ngIf="ordDetail['loyalty_applied']">{{ 'myaccount.l_points' | translate }} : ({{ordDetail['loyalty_points_spent']}})  AED - {{ordDetail['loyalty_points_amount']}} </span><br>
                                  <span *ngIf="ordDetail['shiping_chrg'] !=null">{{ 'checkout.delivery_charge' | translate }}: AED + {{ordDetail['shiping_chrg']}} </span><br>
                                  <p class="mt-3 mb-1"> {{ 'ord_detail.net_paid' | translate }} : AED {{ordDetail['netPaid']}}</p>
                                  <span>{{ 'checkout.included_tax' | translate }}(5%): AED {{ordTax}}</span>

                              </div> 
                            </div>

                             </div>
                             
                        </div>          

                    </div>
                    </div>
                  </div>
              </div>
          </div>
      </section>